import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";
import {FormattedMessage} from "react-intl";

import './UserAccountUpdatedPopUp.style.scss';
const UserAccountUpdatedPopUp = ({id, open, onClose, onCancel, onOk, options}) => {
    return (
        <Dialog open={open} onClose={onClose} className="UserAccountUpdatedPopUp">
            <DialogContent className="UserAccountUpdatedContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    {options.title}
                </Typography>
                <Typography className="subTitle">
                    {options.subTitle}
                </Typography>
                <div className={'actionButton'}>
                    <Button className="login" onClick={() => {
                        onOk()
                    }}>
                        <FormattedMessage id={'popUp.AccountDetailsChanged.ok'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default UserAccountUpdatedPopUp;
